export const NetpayOnHoldListFiltersMap = {
  departments: 'departments[]',
  locations: 'locations[]',
  search: 'search',
  page: 'page',
  limit: 'limit',
} as const;
